import './style.scss'
import {
  PopupManager
} from 'element-ui/lib/utils/popup'
export function createTablePopover () {
  return {
    props: {
      transition: {
        type: String,
        default: 'fade-in-linear'
      },
      popperClass: String,
      content: String | HTMLElement | Object,
      visibleArrow: {
        type: Boolean,
        default: true
      },
      value: {
        type: Boolean,
        default: false
      },
      width: {
        type: Number,
        default: 200
      },
      wrapClass: {
        type: String,
      },
      effect: {
        type: String,
        default: 'light'
      }
    },
    render (_) {
      const { transition, popperClass, content, visibleArrow, width, value, wrapClass, effect } = this
      const effectClassName = effect === 'light' ? 'kye-plugin-popover-light' : 'kye-plugin-popover-dark'
      const className = ['kye-plugin-popper el-popper el-popover', effectClassName, wrapClass, popperClass, content && 'el-popover--plain'].filter(Boolean)
      const style = {
        width: isFinite(width) ? width + 'px' : width,
        display: value ? 'block' : 'none',
        zIndex: PopupManager && PopupManager.nextZIndex()
      }
      return <transition
        name={transition}
      >
        <div
          ref="popper"
          style={style}
          class={className}
        >
          {
            visibleArrow ? <div x-arrow="" class="popper__arrow"></div> : null
          }
          <div domPropsInnerHTML={content}></div>
        </div>
      </transition>
    }
  }
}




// WEBPACK FOOTER //
// ./src/public/components/kye-edit-table/popover/component.js